/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect, useRef } from "react";
import * as API from "../../http/api";
import { openlightbox } from "../../util/Functions";
import { formatDateTimewithoutTime } from "../../util/DateUtil";
import { CardHeader, Grid, IconButton, Tooltip, Typography, Button, TextField, MenuItem, ThemeProvider, Box, InputAdornment } from "@mui/material";
import { Download, Edit, Search } from "@mui/icons-material";
import R27 from "./../../components/modals/R27";
import { R27Report } from "../modals";
import { theme, customStyles2, iconStyle } from "../../util/TableStyles"
import DescriptionIcon from '@mui/icons-material/Description';
import DataTable from "react-data-table-component";
import { noDataComponent } from "../../util/DataObject"
import { initDay, transormDates } from "../elements/DateRangePicker";
import CustomPagination from "../elements/CustomPagination";
import { CommonService } from '../../services/CommonService';
import { Card } from '@albo-ui/core';
import moment from 'moment';
moment.locale('es');

const R27List = (props) => {
  const [endDate, setEndDate] = useState(new Date().toJSON());
  const [startDate, setStartDate] = useState(initDay);
  const [list, setList] = useState([]);
  const [searchFolio, setSearchFolio] = useState("");

  const classes = iconStyle();
  const status = [
    { value: "all", label: "Todos" },
    { value: "101", label: "Pendiente" },
    { value: "103", label: "Reapertura Pendiente" },
    { value: "102", label: "Concluida" },
    { value: "104", label: "Reapertura concluida" },
  ]
	const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(20);
  const [totalDocuments, setTotalDocuments] = useState(0);
  const [selectStatus, setSelectStatus] = useState("all");
  const commonService = useRef<CommonService>();

  useEffect(() => {
    setList(props.content);
    setTotalDocuments(props.pagination['total_documents'])
    commonService.current = new CommonService(props.changeAlert)
  }, []);

  const filter = async (payload= null) => {
    props.changeLoader(true);
    var dates = transormDates({start: startDate, end: endDate})

    var data = {
      operation: "getByPeriod",
      data: {
        start: dates.start,
        end: dates.end,
        filters: {
          page_number: 1,
          results_per_page: rowsPerPage
        }
      },
    };
    !payload && setPage(1)
    selectStatus === "all" ? delete data['data'][ 'filters' ][ 'status_complaint' ] : data['data']['filters']['status_complaint'] = selectStatus

    let request = await API.service('r27', payload ? payload : data, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        var response = request.data.data.widget[0].content.data;
        setList(response.content);
        setTotalDocuments(response.pagination['total_documents']);
      }
    }
    window.scrollTo({ top: 0, behavior: 'smooth' });
    props.changeLoader(false);
  };

  const onSearchByFolio = async () => {
    props.changeLoader(true);

    var dataRequest = {
      operation: "getByFolio",
      data: {
        id_complaint: searchFolio
      }
    };

    let request = await API.service('r27', dataRequest, props.pos, props.changeAlert, props.changeLoader, props.history);
    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        var response = request.data.data.widget[0].content.data;
        setList(response.content);
        setTotalDocuments(response.content.length);
        setSearchFolio("");
      }
    }
    props.changeLoader(false);
  };

  const exportar = (item: any) => {
    const as = (
      <R27Report
        pos={props.pos}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
      />
    );
    openlightbox(as);
  }

  const changeDayStart = (e) => {
    setStartDate(new Date(e.target.value).toISOString());
  };

  const changeDaysEnd = (e) => {
    setEndDate(new Date(e.target.value).toISOString());
  };

  const formatDate = (date) => {
    return formatDateTimewithoutTime(date);
  };

  const changeSelect = (e) => {
    setSelectStatus(e.target.value);
  };

  const stausCatalog = (status) => {
    switch (status) {
      case "101": {
        return "Pendiente";
      }
      case "102": {
        return "Concluida";
      }
      case "103": {
        return "Reapertura Pendiente";
      }
      case "104": {
        return "Reapertura concluida";
      }
    }
    return "";
  };

  const changeFolio = (e) => {
    setSearchFolio(e.target.value)
  }

  const getR27 = async (data) => {
    props.changeLoader(true);
    var dataRequest = {
      operation: "getByTrxId",
      data: {
        uuid: data.uuid,
      },
    };
    let request = await API.service('r27', dataRequest, props.pos, props.changeAlert, props.changeLoader, props.history);

    if (request.status == 200) {
      if (request.data.data.response == "OK") {
        if (request.data.data.widget[0].content.data.content[0]) {
          let content = request.data.data.widget[0].content.data.content

          let dataSend = content.filter((item) => {
            if(item.status_complaint === data.status_complaint){
              return item
            }
          })[0];

          let customerUuid = {
            uuid: dataSend.customer_uuid,
          };
          let getCatalogs = await catalogGet()

          dataSend.hasUpdate = true;
          const as = (
            <R27
              data={dataSend}
              pos={props.pos}
              spacesList={props.spacesList}
              spaceUuid={props.spaceUuid}
              changeAlert={props.changeAlert}
              changeLoader={props.changeLoader}
              customer={customerUuid}
              hasFilter={true}
              filter={filter}
              catalogs={getCatalogs}
              config={props.config}
            />
          );
          openlightbox(as);
        }
      }
      props.changeLoader(false);
    }
  };

  const catalogGet = async () => {
      let payload = {
          catalog: {
              id: "chargebacks_reason"
          }
      };

      const response = await commonService.current.getCatalog(payload);
      if(response?.data?.response === 'OK'){
          let catalogResp = response.data.catalog;
          let resolve_catalog = catalogResp.filter((c) => c.m[0]['action_type'] === "resolve");
          resolve_catalog.sort(comparar);

          let reason_catalog = catalogResp.filter((c) => c.m[0]['action_type'] === "complaint");
          reason_catalog.sort(comparar);

          return [resolve_catalog, reason_catalog]
      } else {
          props.changeAlert(true, 'error', response.data.message);
      }
  }

  function comparar(a: Object, b: Object) {
      return a['k'].localeCompare(b['k']);
  }

  const columns = [
    { selector: (row) => formatDate(row.complaint.cdate), name: "Fecha reclamo", width: "14%", wrap: true, sortable: true },
    { selector: (row) => stausCatalog(row.status_complaint), name: "Estatus reclamo", width: "18%", sortable: true },
    { selector: (row) => row.id_complaint, name: "Folio", width: "14%", sortable: true },
    { selector: (row) => formatDate(row.udate_status), name: "Actualización estatus", width: "20%", wrap: true, sortable: true },
    { selector: (row) => row.event.amount.toFixed(2), name: "Monto", width: "10%", sortable: true },
    // { selector: (row) => row.status, name: "Status", width: "11%", sortable: true },
    {
      sortable: true, width: "4%",
      cell: (item) => {
        return (
          <Tooltip title="Editar">
            <IconButton onClick={getR27.bind(this, item)}>
              <Edit />
            </IconButton>
          </Tooltip>
        );
      },
    },
    {
      sortable: true, width: "4%",
      cell: (item, index) => {
        return (
          <Tooltip title="Descargar JSON">
            <IconButton onClick={exportar.bind(this, index)}>
              <Download />
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const changePage = (action, page, rows= rowsPerPage) => {
		setPage(page+1);
    var dates = transormDates({start: startDate, end: endDate})

		let payload = {
      operation: "getByPeriod",
      data: {
        start: dates.start,
        end: dates.end,
        filters: {
          page_number: page+1,
          results_per_page: rows
        }
      },
    };
    selectStatus === "all" ? delete payload['data'][ 'filters' ][ 'status_complaint' ] : payload['data']['filters']['status_complaint'] = selectStatus

    filter(payload);
	};

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setRowsPerPage(JSON.parse(JSON.stringify(event.target.value)));
		changePage(null, 0, parseInt(event.target.value, 10));
	};

  const events = [
    { selector: (row) => formatDate(row.cdate), name: "Fecha evento", width: "20%", wrap: true, sortable: true },
    { selector: (row) => row.movement_id, name: "ID Movimiento", width: "25%", wrap: true, sortable: true },
    { selector: (row) => row.amount.toFixed(2), name: "Monto", width: "15%", wrap: true, sortable: true },
    { selector: (row) => row.description, name: "Descripción", width: "40%", wrap: true, sortable: true },
  ];

  const viewInfo = (row) => {
    return (
      <Box className="dataBlock" ml={"4rem"}>
        <div className="report_display">
          <label className="neutral" style={{ width: "36%" }}>Fecha del evento</label>
          <p>{row.data.event.cdate ? formatDate(row.data.event.cdate) : "N/A"}</p>
        </div>
        {row.data.status_complaint !== '101' && row.data.status_complaint !== '103' &&
          <>
            <div className="report_display">
              <label className="neutral" style={{ width: "36%" }}>Quebranto para albo</label>
              <p>{row.data["resolve"]["quebranto"] ? row.data["resolve"].quebranto : "N/A"}</p>
            </div>
            <div className="report_display">
              <label className="neutral" style={{ width: "36%" }}>Importe recuperado</label>
              <p>{row.data["resolve"]["ramount"] ? row.data["resolve"].ramount.toFixed(2) : "N/A"}</p>
            </div>
            <div className="report_display">
              <label className="neutral" style={{ width: "36%" }}>Fecha abono a la cuenta del cliente</label>
              <p>{row.data["resolve"]["pdate"] ? formatDate(row.data["resolve"].pdate) : "N/A"}</p>
            </div>
          </>
        }
        <div className="report_display">
          <label className="neutral" style={{ width: "36%" }}>Reporte</label>
          <p>{row.data.report}</p>
        </div>
        <div className="report_display">
          <label className="neutral" style={{ width: "36%" }}>Descripción</label>
          <p>{row.data["complaint"]["description"] ? row.data.complaint.description : "N/A"}</p>
        </div>

        {row.data.subsequent_events && row.data.subsequent_events.length > 0 &&
          <>
            <hr />
            <div className="report_display">
              <label className="neutral">Eventos subsequentes</label>
            </div>

            <div style={{ paddingBottom: 15}}>

              <ThemeProvider theme={theme}>
                <DataTable
                  columns={events}
                  data={row.data.subsequent_events}
                  dense
                  highlightOnHover
                />
              </ThemeProvider>
              </div>
          </>
        }
      </Box>
    )
  };

  return (
    <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{borderColor: "#EDF0F4"}}> 
      <CardHeader
        sx={{ marginBottom: 2 }}
        title={
          <div style={{ display: 'inline-flex' }}>
            <DescriptionIcon />
            <Typography
              component={'h3'}
              fontFamily="Muli,sans-serif"
              fontSize="22px"
              fontWeight={600}
              sx={{ color: '#3E3E42', padding: "0 4px", lineHeight: 1.2 }}
            >
              Reporte regulatorio R27
            </Typography>
          </div>
        }
      />

      <Grid container spacing={2} justifyContent="right" width={"inherit"} my={3}>
        <Grid item xs={2}>
          <TextField
            label="Fecha de inicio"
            onChange={changeDayStart.bind(this)}
            value={startDate ? new Date(startDate).toJSON().substring(0, 10) : startDate}
            type="date" size="small" variant="outlined" InputLabelProps={{ shrink: true }} fullWidth
            InputProps={{ style: { height: "40px"}}}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            label="Fecha de cierre"
            onChange={changeDaysEnd.bind(this)}
            value={endDate ? new Date(endDate).toJSON().substring(0, 10) : endDate}
            type="date" size="small" variant="outlined" InputLabelProps={{ shrink: true }} fullWidth
            InputProps={{ style: { height: "40px"}}}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            label={'Folio'} value={searchFolio} color='secondary' size='small' fullWidth 
            InputProps={{
                style: {height: 40},
                endAdornment: (
                  searchFolio && <InputAdornment position="end">
                    <IconButton onClick={onSearchByFolio.bind(this)} edge="end">                
                      <Search />
                    </IconButton> 
                  </InputAdornment>
                ),
            }} 
            onChange={changeFolio.bind(this)}
        />
        </Grid>
        <Grid item xs={2}>
          <TextField label="Estatus" onChange={changeSelect.bind(this)} select size="small" fullWidth value={selectStatus}>
            <MenuItem disabled>Seleccione</MenuItem>
            {status.map((p) => (
              <MenuItem key={p.value} value={p.value}>{p.label}</MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item container xs={'auto'}>
          <Grid item >
            <Button variant="contained" onClick={filter.bind(this, null)} >Buscar</Button>
          </Grid>
          <Grid item >
            <Tooltip title="Descargar">
              <IconButton onClick={exportar.bind(this, -1)} sx={{ padding: 0 }}>
                <Download className={classes.icon1} />
              </IconButton>
            </Tooltip>
          </Grid>
        </Grid>
      </Grid>

      <div style={{ width: "100%", margin: "auto" }}>
        <ThemeProvider theme={theme}>
          <DataTable
            columns={columns}
            data={list}
            expandableRows={true}
            expandOnRowClicked={false}
            expandableRowsComponent={viewInfo}
            noDataComponent={noDataComponent}
            customStyles={customStyles2}
            highlightOnHover
          />
          <CustomPagination 
            rows={totalDocuments}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            handleChangePage={changePage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </ThemeProvider>
      </div>
    </Card>
  );
};

export default R27List;
